<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                {{ $route.params.id ? 'Editar' : 'Cadastrar' }} Cidade
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <form id="form">
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Cidade:
                                            </label>
                                            <textarea
                                                v-model="cityDestination.description"
                                                class="form-control"
                                                cols="10"
                                                rows="2"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="block text-right">
                                        <router-link
                                            to="/cityDestinations"
                                            class="btn btn-back"
                                        >
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Voltar
                                        </router-link>
                                        <a
                                            class="btn btn-add"
                                            @click="save"
                                        >
                                            Salvar
                                            <i class="fa fa-save ml-2"></i>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cityDestination: {
                description: "",
            },

            errors: undefined,
        };
    },
    computed: {},
    methods: {
        save: function () {
            let api = this.$store.state.api + "cityDestinations";
            const self = this;

            let fd = new FormData();

            if (self.cityDestination.id) {
                api += "/" + self.cityDestination.id;
                fd.append("id", self.cityDestination.id);
                fd.append("_method", "PUT");
            }

            fd.append("description", self.cityDestination.description)

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message("Sucesso", `Cidade cadastrada com sucesso`, "success");
                    this.$router.push("/cityDestinations");
                })
                .catch((error) => {
                    self.errors = error.response.data;

                    if (typeof self.errors === "object") {
                        let html = "<ul>";

                        $.each(self.errors, function (key, value) {
                            html += "<li>" + value[0] + "</li>";
                        });

                        html += "</ul>";

                        self.errors = html;
                    }

                    self.$message(null, self.errors, "error");
                });
        },
        getEntity(id) {
            const api = this.$store.state.api + "cityDestinations/" + id;
            const self = this;

            self.$http
                .get(api)
                .then((response) => {
                    self.cityDestination = response.data.data[0];
                })
                .catch((error) => {
                    self.$message(null, "Não foi possível encontrar a cidade", "error");
                });
        },
    },
    mounted: function () {
        const self = this;
        let id = self.$route.params.id;
        if (id) {
            self.getEntity(id);
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CityDestination/Add.vue